// extracted by mini-css-extract-plugin
module.exports = {"main_title":"Vstupnykam_main_title__QX-8F","person":"Vstupnykam_person__qfZQU","photo":"Vstupnykam_photo__3AQIK","text":"Vstupnykam_text__1FnMH","name":"Vstupnykam_name__o9lJL"};